const keys = {
	Escape: 27,
};

export { keys };



// WEBPACK FOOTER //
// ./src/util/keys.js